module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-card', {
    staticClass: "mt-10",
    attrs: {
      "body-style": {
        padding: '40px 20px'
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 22,
      "sm": 10,
      "md": 10,
      "lg": 10,
      "offset": 1
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("发布者基本信息")])]), _vm._v(" "), _c('ul', {
    staticClass: "publisher-list-item"
  }, [_c('li', [_vm._v("\n                              发布间隔时间：\n                              "), _c('el-tag', [_vm._v(_vm._s(_vm.publisherInfo.interval))]), _vm._v(" "), _c('span', [_vm._v("分钟")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                              发布新闻条数：\n                              "), _c('el-tag', [_vm._v(_vm._s(_vm.publisherInfo.step))]), _c('span', [_vm._v("条")])], 1), _vm._v(" "), _c('li', [_vm._v("\n                              状态：\n                              "), _c('el-tag', {
    attrs: {
      "type": _vm.publisherInfo.state ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.publisherInfo.serverTime))])], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 22,
      "sm": 10,
      "md": 11,
      "lg": 11,
      "offset": 1
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("修改发布者参数")])]), _vm._v(" "), _c('el-form', {
    ref: "publisher",
    attrs: {
      "model": _vm.publisher,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发布间隔时间",
      "prop": "interval"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.publisher.interval),
      callback: function($$v) {
        _vm.$set(_vm.publisher, "interval", $$v)
      },
      expression: "publisher.interval"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布新闻条数",
      "prop": "step"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.publisher.step),
      callback: function($$v) {
        _vm.$set(_vm.publisher, "step", $$v)
      },
      expression: "publisher.step"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setPublisherConfirm('publisher')
      }
    }
  }, [_vm._v("设置")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b22f9dca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/publisher.vue
// module id = 775
// module chunks = 6